import {Component, computed, inject, OnInit} from '@angular/core';
import {DropdownItemComponent} from '../../../../shared/components/dropdown/dropdown-item/dropdown-item.component';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';
import {DropdownComponent} from '../../../../shared/components/dropdown/dropdown.component';
import {EventService} from '../../../../shared/services/event.service';
import {StepComponent} from '../../../../shared/components/stepper/step/step.component';
import {StepperComponent} from '../../../../shared/components/stepper/stepper.component';
import {CompareStore} from '../../compare.store';
import {ToastService} from '../../../../shared/services/toast.service';
import {LinkComponent} from '../../../../shared/components/link/link.component';
import {TourService} from '../../../../shared/tour/tour.service';
import {AccessService} from '../../../../shared/services/access.service';

@Component({
  selector: 'app-compare-header',
  imports: [
    DropdownItemComponent,
    IconsComponent,
    DropdownComponent,
    StepComponent,
    StepperComponent,
    LinkComponent
  ],
  templateUrl: './compare-header.component.html',
  styleUrl: './compare-header.component.css',
})
export class CompareHeaderComponent implements OnInit {
  private eventService = inject(EventService);
  access = inject(AccessService);
  private compareStore = inject(CompareStore);
  private toastService = inject(ToastService);
  tourService = inject(TourService);

  readonly settingsVisible = computed(() => this.access.has('edit_settings'));
  readonly settingsDisabled = computed(() => this.access.cannot('edit_settings'));

  readonly emailVisible = computed(() => this.access.has('send_quote_via_email'));
  readonly emailDisabled = computed(() => this.access.cannot('send_quote_via_email'));

  readonly textVisible = computed(() => this.access.has('send_quote_via_text'));
  readonly textDisabled = computed(() => this.access.cannot('send_quote_via_text'));

  readonly printVisible = computed(() => this.access.has('send_quote_via_print'));
  readonly printDisabled = computed(() => this.access.cannot('send_quote_via_print'));

  readonly shareVisible = computed(() => this.emailVisible() || this.textVisible() || this.printVisible());
  readonly shareDisabled = computed(() => this.emailDisabled() && this.textDisabled() && this.printDisabled());

  ngOnInit() {
    this.registerTour();
  }

  public share(type: 'text' | 'email' | 'print') {
    this.compareStore.createSnapshot().subscribe({
      next: ({token}) => {
        const link = `${window.location.origin}/select/${token}`;
        this.eventService.emit('share-compare-link', {type, link, items: this.compareStore.snapshot()});
      },
      error: (err: Error) => {
        this.toastService.error(err.message ?? 'Failed to create share link. Please try again.');
      },
    });
  }

  print() {
    window.print();
  }

  private registerTour() {
    this.tourService.register('compare', [
      {
        attachTo: {element: '#compare-share-button'},
        title: 'Share',
        text: 'Customer can review their options and make a selection'
      },
      {
        attachTo: {element: '#compare-save-for-later'},
        title: 'Save for Later',
        text: 'Save the current comparison so it can be reopened later from your management system'
      },
      {
        attachTo: {element: '#compare-quote'},
        title: 'Quote',
        text: 'Select an option then add it to the repair order'
      },
      {
        attachTo: {element: '#compare-quote-po'},
        title: 'Open PO',
        text: 'Adds the item to the repair order and stages it on an open purchase order'
      },
      {
        attachTo: {element: '#compare-quote-po-submit'},
        title: 'Order',
        text: 'Does everything the Quote and Open PO steps do, then submits the order directly to the vendor'
      },
      {title: 'You\'re All Set!', text: 'That covers the compare page — select your option, choose how to add it, and confirm', arrow: false},
    ]);
  }
}
